import { Component, OnInit } from '@angular/core';
import { Utilities } from '../../../helper/util';
import { InputComponent, MakeProvider } from '../input-component';

@Component({
  selector: 'app-email-input',
  templateUrl: './email-input.component.html',
  styleUrls: ['./email-input.component.scss', '../form-inputs-style.scss'],
  providers: [MakeProvider(EmailInputComponent)]
})
export class EmailInputComponent extends InputComponent implements OnInit {

  override placeholder: string = "example@email.com";

  constructor() { super(); }

  ngOnInit() { }

  override checkValidity() {
    super.checkValidity();
    if (this.isValid) {
      if (this.required || !Utilities.stringEmpty(this.value)) {
        const valid = Utilities.isValidEmail(this.value);
        if (!valid) {
          this.focusInvalidElement(this.errorMessage ?? 'Please enter a valid email.');
          this.checkingValidity.emit(this);
        }
      }
    }
  }

}
